// extracted by mini-css-extract-plugin
export default {"iconColor":"form-section-social_iconColor__dRyK7"};